/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {useState, useEffect} from "react";
import {cloneDeep} from "lodash";
import PropTypes from "prop-types";
import {Collapse} from "reactstrap";
import {FaMinus, FaPlus} from "react-icons/fa";
import Select from "react-select";

const TreeSelector = (props) => {
  const {
    options = [],
    childrenKey = "children",
    defaultValue = [],
    onChange = () => {},
    ...rest
  } = props;
  const [value, setValue] = useState(defaultValue);
  const [collapse, setCollapse] = useState(
    options.reduce(
      (prevValue, currentValue) => ({
        ...prevValue,
        [`collapse-${currentValue.value}`]: false,
      }),
      {}
    )
  );

  useEffect(() => {
    if (JSON.stringify(value) !== JSON.stringify(defaultValue)) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(defaultValue)]);

  const handleParentSelection = (parent) => {
    const newValue = cloneDeep(value);
    const parentIndex = newValue.findIndex((ele) => ele.value === parent.value);
    if (parentIndex === -1) {
      setValue([...newValue, parent]);
      onChange([...newValue, parent]);
    } else {
      newValue[parentIndex] = parent;
      setValue(newValue);
      onChange(newValue);
    }
  };

  const handleParentRemove = (parent) => {
    const newValue = cloneDeep(value);
    const parentIndex = newValue.findIndex((ele) => ele.value === parent.value);
    newValue.splice(parentIndex, 1);
    setValue(newValue);
    onChange(newValue);
  };

  const isParentSelected = (parent) => {
    return value.some(
      (ele) =>
        ele?.value === parent?.value &&
        parent[childrenKey]?.length === ele[childrenKey]?.length
    );
  };

  const handleParentClick = (parent) => {
    const isSelected = isParentSelected(parent);
    if (isSelected) {
      handleParentRemove(parent);
    } else {
      handleParentSelection(parent);
    }
  };

  const handleChildSelection = (parent, child) => {
    const newValue = cloneDeep(value);
    const parentIndex = newValue.findIndex((ele) => ele.value === parent.value);
    if (parentIndex === -1) {
      const payload = [
        ...newValue,
        {label: parent.label, value: parent.value, [childrenKey]: [child]},
      ];
      setValue(payload);
      onChange(payload);
    } else {
      const selectedParent = cloneDeep(value[parentIndex]);
      const selectedChilds = Array.isArray(selectedParent[childrenKey])
        ? cloneDeep(selectedParent[childrenKey])
        : [];
      newValue[parentIndex] = {
        label: parent.label,
        value: parent.value,
        [childrenKey]: [...selectedChilds, child],
      };
      setValue(newValue);
      onChange(newValue);
    }
  };

  const handleChildRemove = (parent, child) => {
    const newValue = cloneDeep(value);
    const parentIndex = newValue.findIndex((ele) => ele.value === parent.value);
    const selectedParent = cloneDeep(value[parentIndex]);
    const selectedChilds = Array.isArray(selectedParent[childrenKey])
      ? cloneDeep(selectedParent[childrenKey])
      : [];
    const childrenIndex = selectedChilds.findIndex((ele) => ele.value === child.value);
    selectedChilds.splice(childrenIndex, 1);
    if (selectedChilds.length === 0) {
      // Remove the parent if no children are left
      newValue.splice(parentIndex, 1);
    } else {
      newValue[parentIndex] = {
        label: parent.label,
        value: parent.value,
        [childrenKey]: selectedChilds,
      };
    }
    setValue(newValue);
    onChange(newValue);
  };

  const isChildSelected = (parent, child) => {
    const isChildSelected = value.some((parentElement) => {
      const childs = parentElement[childrenKey] || [];
      return (
        parentElement?.value === parent?.value &&
        childs.some((childElement) => childElement?.value === child?.value)
      );
    });
    return isChildSelected;
  };

  const handleChildClick = (parent, child) => {
    const isSelected = isChildSelected(parent, child);
    if (isSelected) {
      handleChildRemove(parent, child);
    } else {
      handleChildSelection(parent, child);
    }
  };

  const RenderOption = (props) => {
    const {data, innerRef, innerProps} = props;
    const childrenOptions = data[childrenKey] || [];
    const Icon = collapse[`collapse-${data.value}`] ? FaMinus : FaPlus;
    return (
      <div>
        <span className={"d-flex sites-list"}>
          <Icon
            onClick={() =>
              setCollapse({
                ...collapse,
                [`collapse-${data.value}`]: !collapse[`collapse-${data.value}`],
              })
            }
            className={"dropdown-collapse-icon"}
          />
          <div
            ref={innerRef}
            className="custom-control custom-control-alternative custom-checkbox"
            {...innerProps}
            onClick={() => handleParentClick(data)}
          >
            <input
              className="custom-control-input checkbox-style"
              type="checkbox"
              defaultChecked={isParentSelected(data)}
            />
            <label className="custom-control-label" htmlFor=" customCheckLogin">
              <span className="text-muted scope__option">{data.label}</span>
            </label>
          </div>
        </span>

        <Collapse isOpen={collapse[`collapse-${data.value}`]}>
          <ul className="dropdown-collapse-ul">
            {childrenOptions.map((item, index) => {
              return (
                <li
                  key={index}
                  onClick={() => handleChildClick(data, item)}
                  className="location-list"
                >
                  <div className="custom-control custom-control-alternative custom-checkbox">
                    <input
                      className="custom-control-input"
                      type="checkbox"
                      defaultChecked={isChildSelected(data, item)}
                    />
                    <label className="custom-control-label" htmlFor=" customCheckLogin">
                      <span className="text-muted">{item.label}</span>
                    </label>
                  </div>
                </li>
              );
            })}
          </ul>
        </Collapse>
      </div>
    );
  };

  const MultiValueContainer = (props) => {
    const {data = {}, innerRef, innerProps} = props;
    const childrenOptions = data[childrenKey] || [];

    if (isParentSelected(options.find((option) => option.value === data.value))) {
      return (
        <div
          ref={innerRef}
          {...innerProps}
          className="d-flex border border-1 p-0 px-2 rounded"
        >
          <p className="m-0">{data.label} </p>
          <div
            ref={innerRef}
            {...innerProps}
            className={"selectClose"}
            onClick={() => handleParentRemove(data)}
          >
            x
          </div>
        </div>
      );
    } else {
      return childrenOptions.map((ele, key) => {
        return (
          <div
            className="d-flex border border-1 p-0 px-2 rounded"
            key={key}
            ref={innerRef}
            {...innerProps}
          >
            <p className="m-0">{ele.label}</p>
            <div
              ref={innerRef}
              {...innerProps}
              className={"selectClose"}
              onClick={() => handleChildRemove(data, ele)}
            >
              x
            </div>
          </div>
        );
      });
    }
  };

  return (
    <div>
      <Select
        defaultMenuIsOpen={false}
        closeMenuOnSelect={false}
        components={{Option: RenderOption, MultiValueContainer}}
        options={options}
        value={value}
        hideSelectedOptions={false}
        isMulti
        isClearable={false}
        {...rest}
      />
    </div>
  );
};

TreeSelector.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      children: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
      ),
    })
  ).isRequired,
  defaultValue: PropTypes.array,
  childrenKey: PropTypes.string,
  onChange: PropTypes.func,
};

export default TreeSelector;
